<template>
	<div class="flex text_left margin_top">
		<md-checkbox style="margin-top: 5px;"
					 :class="[{ 'md-error': errors.has(validationName) }]"
					 v-model="value"
					 v-validate="validationRules"
					 :data-vv-name="validationName"
					 :required="validationRules.checked"
		/>
		<span>
			{{ (isMultiple ? $t("seller.upload.noSanctionsConfirmation.plural") : $t("seller.upload.noSanctionsConfirmation.single")) + (validationRules.checked ? "*" : "") }}
			<span v-if="errors.has(validationName)" class="validation-error validation-inline">
				{{ errors.first(validationName) }}
			</span>
		</span>
	</div>
</template>

<script>
import {Validator} from "vee-validate";

export default {
	props: {
		value: { type: Boolean, default: false },
		validationRules: { type: Object, default: { checked: false} },
		validator: { type: Validator }, // Parent validator instance since the default Vue inject mechanism leads to problems with the modal this is embedded in
		isMultiple : { type: Boolean, default: false },
	},
	data() {
		return {
			validationName: "noSanctionsConfirmation"
		};
	},
	created() {
		// Update the internal validator instance
		this.$validator = this.validator;
	},
	watch: {
		value() {
			this.$emit("input", this.value);
		}
	},
};
</script>